import {
  FilteringModel,
  OwnQuery,
  SubjectServiceModel,
} from '@archiwum/shared/table';
import { CaseServiceQuery } from '../../services/case-service-query';

export function getSpisNASQuery(
  query: OwnQuery,
  result: SubjectServiceModel,
  search: string,
  filters: FilteringModel[],
  dispatch: (data: unknown) => void
) {
  CaseServiceQuery.GetSpisNAS({
    pageInfo: { pageNumber: query.page, pageSize: query.pageSize },
    filtersConjunction: filters,
    sort: query.sort,
    searchValue: search,
    searchBy: search,
    foldery: [],
  }).subscribe({
    next: (value) => {
      const data = value.items.map((item, index) => ({
        ...item,
        index: index + 1,
      }));
      dispatch?.({ data });
      return result.onSuccess({
        data,
        page: value.pageInfo.pageNumber,
        totalCount: value.pageInfo.totalItems,
      });
    },
    error: (err) => {
      return result.onError();
      // reject();
    },
  });
}

export function getSpisSprawQuery(
  query: OwnQuery,
  result: SubjectServiceModel,
  search: string,
  filters: FilteringModel[],
  dispatch: (data: unknown) => void
) {
  CaseServiceQuery.GetSpisSpraw({
    pageInfo: { pageNumber: query.page, pageSize: query.pageSize },
    filtersConjunction: filters,
    sort: query.sort,
    searchValue: search,
    searchBy: search,
    foldery: [],
  }).subscribe({
    next: (value) => {
      const data = value.items.map((item, index) => ({
        ...item,
        index: index + 1,
      }));
      dispatch?.({ data });
      return result.onSuccess({
        data,
        page: value.pageInfo.pageNumber,
        totalCount: value.pageInfo.totalItems,
      });
    },
    error: (err) => {
      return result.onError();
      // reject();
    },
  });
}
